import React, {memo, useCallback, useState} from "react";
import {useTranslation} from "react-i18next";
import {usePresetsContext} from "../../../context/presetsContext";
import {useTraceRoutesToNetwork} from "../../../hooks/transitlLines/useTraceRoutesToNetwork";
import {useToastContext} from "../../../context/toastContext";
import {getFilledFieldsObjOnFormSubmit, isErrorResponse, safelyParseJson} from "../../../utils/utils";
import {TraceRouteToNetworkData} from "../../../api/presetsApi/types";
import {Button} from "../../../components";
import {createPortal} from "react-dom";
import Modal from "../../../components/Modal/Modal";
import {Form, Row} from "../../../components/form/Form/Form";
import * as SelectBox from "../../../components/form/SelectBox/SelectBox";
import {LoadingComponent} from "../../../components/LoadingComponent/LoadingComponent";
import {ActionsProps} from "../../../components/Entities/EntitiesLoader/EntitiesLoader";
import {Tooltip} from "@mui/material";
import {PublicTransitLayerEntityName} from "../../../api/entities/replancity_PublicTransitLine";
import {useTypedSelector} from "../../../redux/Hooks/storeSelectors";
import {selectMapLayerIdByEntityName} from "../../../redux/selectors/selectors";
import {setSourceReloadRequired} from "../../../redux/map/map-reducer";
import {useDispatch} from "react-redux";


const TraceRouteToNetwork = memo(({id}: ActionsProps) => {
    const routeEntityName = PublicTransitLayerEntityName.ROUTES;
    const sourceId = useTypedSelector((state) => selectMapLayerIdByEntityName(state, routeEntityName));
    const [modalVisible, setModalVisible] = useState<boolean>(false);
    const {selectedPresetId} = usePresetsContext();
    const {loading, loadRoadPresets, roadPresetsOptions, traceRouteToNetwork} = useTraceRoutesToNetwork();
    const {addToast} = useToastContext();
    const {t} = useTranslation();
    const dispatch = useDispatch();

    const handleBtnClick = useCallback(async () => {
        setModalVisible(true);
        await loadRoadPresets();
    }, [setModalVisible, loadRoadPresets])

    const onFormSubmit = useCallback(async (event) => {
        const formDataObj = getFilledFieldsObjOnFormSubmit(event);
        formDataObj['transitRouteId'] = id;
        const resp = await traceRouteToNetwork(formDataObj as TraceRouteToNetworkData);

        if (isErrorResponse(resp)) {
            const error = typeof resp.error === 'string' ? safelyParseJson(resp.error) : resp.error;
            addToast(`${error?.['details'] ?? t('transit-lines.trace-to-network-error')}`, 'error');
        } else {
            addToast(`${t('transit-lines.trace-routes-to-network-successful')}`, 'success');
            if (sourceId) {
                dispatch(setSourceReloadRequired({sourceId, isReloadRequired: true}));
            }
        }
        setModalVisible(false);
    }, [id, sourceId, setModalVisible, traceRouteToNetwork]);

    return (
        <>
            <Tooltip title="345" placement="top">
                <div>
                    <Button
                        text="t"
                        size="small"
                        onClick={handleBtnClick}
                        disabled={!selectedPresetId}
                        colorType="transparent"
                    />
                </div>
            </Tooltip>
            {modalVisible && createPortal(
                <Modal title={t("transit-lines.trace-route-to-network-form-title")} setVisible={setModalVisible}>
                    <LoadingComponent isLoading={loading}>
                        <Form
                            name="traceRoutesForm"
                            onSubmit={onFormSubmit}
                            submitBtnTitle={t('transit-lines.trace-route-to-network-btn')}
                            disabled={!selectedPresetId}
                        >
                            <Row>
                                <SelectBox.Labeled
                                    label={t('transit-lines.road-preset')}
                                    name='roadPresetId'
                                    options={roadPresetsOptions}
                                />
                            </Row>
                        </Form>
                    </LoadingComponent>
                </Modal>,
                document.getElementById('root') as any)
            }
        </>
    )
})

export default TraceRouteToNetwork;